import { useParams } from "react-router-dom";
import { nameOf } from "../../../Utils/nameOf";
import { useDeleteRateAgreement } from "../Hooks/useDeleteRateAgreement";
import { useFetchRateAgreement } from "../Hooks/useFetchRateAgreement";
import { useUpdateRateAgreement } from "../Hooks/useUpdateRateAgreement";
import { RateAgreement } from "../RateAgreement";
import { RateAgreementFormTabs } from "./RateAgreementFormTabs";

export const EditRateAgreement = () => {
  const { rateAgreementId } = useParams();
  const { data: rateAgreement } = useFetchRateAgreement(rateAgreementId);

  const { mutate: updateRateAgreement } = useUpdateRateAgreement(rateAgreementId);

  const { mutate: deleteRateAgreement } = useDeleteRateAgreement(rateAgreementId);

  const disabledFields: Array<string> = [
    nameOf<RateAgreement>("RateAgreementNumber"),
    nameOf<RateAgreement>("CarrierId"),
    nameOf<RateAgreement>("Version"),
  ];

  return (
    <RateAgreementFormTabs
      title="Edit"
      rateAgreement={rateAgreement}
      onSave={(it: RateAgreement) => updateRateAgreement(it)}
      onDelete={() => deleteRateAgreement(rateAgreementId)}
      disabledFields={disabledFields}
      saveButtonText="SAVE"
    />
  );
};
